import React, { Component } from 'react';
import {
    Col, Row
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Teacher from '../../../assets/Images/TeacherLogo.png'
import Assistant from '../../../assets/Images/AssistantLogo.png'
import Student from '../../../assets/Images/StudentLogo.png'
import Parent from '../../../assets/Images/ParentLogo.png'
import String from '../../../assets/Locales/teacher_locales.js';
import SendEmail from './Email/email'
import ResetCode from './resetCode/code'
import ResetPassword from './Reset/resetpassword'
import LoadingBar, { resetLoading } from 'react-redux-loading-bar'
import './forgetpassword.css'

class Login extends Component {
    
    onSubmit = (values) => {
        // console.log(values)
        this.props.LoginRequest(values, localStorage.getItem('Language'))
    }
    render() {
        let lang = localStorage.getItem("Language");
        // console.log("lang", lang)
        if (lang) {
            // console.log("lang in if", lang)
            String.setLanguage(localStorage.getItem("Language"));
        } else {
            // console.log("lang in else", lang)
            lang = "ar"
            String.setLanguage("ar");
        }
        console.log("Page name :",this.props.pageName)
        return (
            <div>
                <div className="loading-bar" >
                    <LoadingBar style={{ height: '5px', zIndex: 1000, backgroundColor: "black" }} />
                </div>
                <div className="login-content" style={{ direction: lang === 'ar' ? 'rtl' : 'ltr' }}>
                    <div className="login-container">
                        <Row className="login-image-content">
                            <Col md="12" className="big-img">
                                <img src={Teacher} alt="Teacher" />
                            </Col>
                            <Col md="12" className="small-imgs">
                                <img src={Student} alt="Student" />
                                <img src={Parent} alt="Parent" />
                                <img src={Assistant} alt="Assistant" />
                            </Col>
                        </Row>
                        <Row className="p-0 m-0" >
                            {this.props.pageName === 'email' && <SendEmail />}
                            {this.props.pageName === 'code' && <ResetCode />}
                            {this.props.pageName === 'resetPassword' && <ResetPassword />}
                        </Row>
                    </div>
                </div>
            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
        pageName: state.forget.page
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {

    }
    , dispatch
)
export default (connect(mapStateToProps, mapDispatchToProps)(Login));